/* global $ */

let currentID = 1;
$.$body.find('.video-share .videoWrapper iframe').each(function() {
  $(this).attr('id', currentID);
  $(this).attr('src', $(this).attr('src') + '&autoplay=0');
  $(this).attr('src', $(this).attr('src') + '&rel=0');
  currentID++;
});

let current = 1;
$.$body.find('.video-cover').each(function() {
  const findVideo = $('#' + current);
  $(this).click(function() {
    $(this).fadeOut();
    $(findVideo).attr(
      'src',
      $(findVideo)
        .attr('src')
        .replace('autoplay=0', 'autoplay=1'),
    );
  });
  current++;
});

// fix popover iframes
$.$body.find('.pop-over .videoWrapper iframe').each(function() {
  $(this).attr('id', currentID);
  $(this).attr('src', $(this).attr('src') + '&autoplay=1');
  $(this).attr('src', $(this).attr('src') + '&rel=0');
  currentID++;
});

$(document).on('click touchstart', (event) => {
  if (!$(event.target).closest('.pop-over .videoWrapper iframe').length) {
    if ($('.pop-over').is(':visible')) {
      $('.pop-over').hide();
      const iFrameSrc = $('.pop-over .videoWrapper iframe').attr('src');
      if (iFrameSrc) {
        $('.pop-over .videoWrapper iframe').attr(
          'src',
          iFrameSrc.replace('autoplay=1', 'autoplay=0'),
        );
      }
    }
  }
});

$.$body.find('.play-button').click((event) => {
  if (!$(event.target).closest('.pop-over .videoWrapper iframe').length) {
    if ($('.pop-over').is(':visible')) {
      $('.pop-over').hide();
    }
  }
});

// prevent ambient video from being played by default, saving data.
function playVideo($video) {
  $video
    .prop('autoplay', true)
    .attr('preload', 'auto')
    .removeClass('unplayed');
  const video = $video.get(0);
  if (video && typeof video.play === 'function') {
    video.play();
  }
}

const $videos = $('body').find('video');
function playVideosIfVisible() {
  if ($videos.filter('.unplayed').length) {
    $('body')
      .find('video')
      .filter('.unplayed')
      .each((i, el) => {
        const $video = $(el);
        if ($video.css('display') === 'block') {
          playVideo($video);
        }
      });
  } else {
    $(window).off('resize', playVideosIfVisible);
  }
}

if ($videos.length) {
  $(window).resize(playVideosIfVisible);
  playVideosIfVisible();
}

// show yt videos on click
$.$body.on('click', '.js-start-video', (e) => {
  const $container = $(e.currentTarget);
  const $btn = $container.closest('.video-button');

  const iframeWindow = $btn
    .addClass('playing')
    .find('iframe')
    .get(0);

  iframeWindow.contentWindow.postMessage(
    JSON.stringify({
      event: 'command',
      func: 'playVideo',
      args: [],
    }),
    '*',
  );
  $container.fadeOut();
  $btn
    .find('.faux-video-overlay')
    .fadeOut()
    .find('.cover-image')
    .fadeOut();
});

window.addEventListener(
  'message',
  (e) => {
    // console.log('message');
    if (e.origin !== 'https://www.youtube.com' || e.data === undefined) return;
    try {
      const data = JSON.parse(e.data);
      // console.log(data, 'yt event');
      if (data.event !== 'onStateChange') return;
      document.querySelector(`#${data.id}`).className += ' playing';
    } catch (error) {
      console.error(error);
    }
  },
  true,
);

Array.from(document.querySelectorAll('iframe')).forEach(
  (iframe, currentFrameId) => {
    iframe.id = `yt-${currentFrameId}`;
    iframe.addEventListener('load', () => {
      // console.log('loaded');
      let message = JSON.stringify({
        event: 'listening',
        id: `yt-${currentFrameId}`,
        channel: 'widget',
      });
      iframe.contentWindow.postMessage(message, 'https://www.youtube.com');

      message = JSON.stringify({
        event: 'command',
        func: 'addEventListener',
        args: ['onStateChange'],
        id: `yt-${currentFrameId}`,
        channel: 'widget',
      });
      iframe.contentWindow.postMessage(message, 'https://www.youtube.com');
    });
  },
);
